enum InvoicePrintAttachmentType {
    InvoicePdf = 'INVOICE_PDF',
    BankSlip = 'BANK_SLIP',
    Nf = 'NF',
    NfFuture = 'NF_FUTURE',
    NfSimpleShipping = 'NF_SIMPLE_SHIPPING',
}

export enum InvoicePrintAttachmentTypeTranslate {
    INVOICE_PDF = 'Pedido',
    BANK_SLIP = 'Boleto',
    NF = 'Nota Venda',
    NF_FUTURE = 'Nota Venda Futura',
    NF_SIMPLE_SHIPPING = 'Nota Simples Remessa',
}

export default InvoicePrintAttachmentType;
